import React, { useState } from 'react';
import { createPortal } from 'react-dom';

type StatusOption = {
  id: string;
  label: string;
};

interface StatusFilterModalProps {
  isOpen: boolean;
  selectedStatusProp?: string[];
  onClose: () => void;
  onApply: (selected: string[]) => void;
}

const statusOptions: StatusOption[] = [
  { id: 'PAUSED', label: 'Paused' },
  { id: 'ENABLED', label: 'Enabled' },
  { id: 'ARCHIVED', label: 'Archived' },
];

export const StatusFilterModal: React.FC<StatusFilterModalProps> = ({
  isOpen,
  onClose,
  selectedStatusProp = [],
  onApply,
}) => {
  const [selectedStatus, setSelectedStatus] = useState<string[]>(selectedStatusProp);

  const toggleStatus = (id: string) => {
    setSelectedStatus((prev) =>
      prev.includes(id) ? prev.filter((s) => s !== id) : [...prev, id]
    );
  };

  const handleApply = () => {
    onApply(selectedStatus);
    onClose();
  };

  if (!isOpen) return null;

  return createPortal(
    <div className="modal fade show d-block" tabIndex={-1} role="dialog">
      <div className="modal-backdrop fade show" onClick={onClose}></div>
      <div className="modal-dialog modal-dialog-centered" role="document" style={{ zIndex: 1050 }}>
        <div className="modal-content shadow rounded-3 border-0" style={{ width: "65%" }}>
          <div className="modal-header border-0">
            <h5 className="modal-title fw-semibold">Status</h5>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            {statusOptions.map((status) => (
              <div className="form-check mb-3" key={status.id}>
                <input
                  className="form-check-input"
                  type="checkbox"
                  id={status.id}
                  checked={selectedStatus.includes(status.id)}
                  onChange={() => toggleStatus(status.id)}
                />
                <label className="form-check-label" htmlFor={status.id}>
                  {status.label}
                </label>
              </div>
            ))}
          </div>
          <div className="modal-footer border-0 pt-0">
            <button className="btn btn-outline-secondary" onClick={onClose}>
              Cancel
            </button>
            <button style={{ height: "38px" }} className="btn btn-primary" onClick={handleApply}>
              Apply
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};
